import { makeStyles } from 'tss-react/mui';

import { paperClasses } from '@mui/material';

export default makeStyles({ name: 'UserMenu' })({
    popover: {
        [`& .${paperClasses.root}`]: {
            display: 'flex',
            flexDirection: 'column',
            minWidth: 280,
            width: 'inherit',
            padding: 12,
            boxSizing: 'border-box',
            boxShadow: '0px 8px 16px 0px rgba(176, 178, 186, 0.10), 0px 12px 32px 0px rgba(176, 178, 186, 0.25)'
        }
    },
    divider: {
        marginTop: 8,
        marginBottom: 8
    },
    action: {
        display: 'flex',
        padding: '12px 4px',
        alignItems: 'center',
        gap: 8,
        justifyContent: 'space-between',
        whiteSpace: 'nowrap',
        borderRadius: 8,
        cursor: 'pointer',
        color: '#232323',
        fontSize: 14,
        fontWeight: 500,
        lineHeight: '16px',
        ['&:hover']: {
            background: '#F5F5F5'
        }
    }
});
